module.exports = __webpack_public_path__ + "static/media/IMG_1146.329180ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/food/IMG_1146.jpg
// module id = 74
// module chunks = 0